module.exports = __webpack_public_path__ + "static/media/4622.224f89db.jpg";